var _path, _path2, _path3, _path4, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailSvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 142,
  height: 152,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("foreignObject", {
  width: 181,
  height: 174.974,
  x: -19.5,
  y: -3.191
}, /*#__PURE__*/React.createElement("div", {
  xmlns: "http://www.w3.org/1999/xhtml",
  style: {
    backdropFilter: "blur(10px)",
    clipPath: "url(#email-svg_svg__a)",
    height: "100%",
    width: "100%"
  }
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#email-svg_svg__b)",
  stroke: "#fff",
  d: "M66.381 18.825 1 57.52v75.764c0 9.941 8.059 18 18 18h104c9.941 0 18-8.059 18-18V57.519L77.577 18.896a10.88 10.88 0 0 0-11.196-.07Z",
  "data-figma-bg-blur-radius": 20
})), /*#__PURE__*/React.createElement("foreignObject", {
  width: 132,
  height: 141.5,
  x: 5,
  y: -12
}, /*#__PURE__*/React.createElement("div", {
  xmlns: "http://www.w3.org/1999/xhtml",
  style: {
    backdropFilter: "blur(6.5px)",
    clipPath: "url(#email-svg_svg__c)",
    height: "100%",
    width: "100%"
  }
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#email-svg_svg__d)",
  fillOpacity: 0.6,
  d: "M18 17c0-8.837 7.163-16 16-16h74c8.837 0 16 7.163 16 16v56.5l-52.5 43L18 71.754z",
  "data-figma-bg-blur-radius": 13
})), /*#__PURE__*/React.createElement("foreignObject", {
  width: 200.002,
  height: 153.898,
  x: -29,
  y: 27.386
}, /*#__PURE__*/React.createElement("div", {
  xmlns: "http://www.w3.org/1999/xhtml",
  style: {
    backdropFilter: "blur(15px)",
    clipPath: "url(#email-svg_svg__e)",
    height: "100%",
    width: "100%"
  }
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#email-svg_svg__f)",
  fillOpacity: 0.7,
  stroke: "#fff",
  d: "m71.792 107.407 68.71-49.05v74.926c0 9.666-7.828 17.5-17.493 17.5H18.959c-9.663 0-17.458-7.831-17.458-17.497V58.349l69.713 49.06.29.204z",
  "data-figma-bg-blur-radius": 30
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M123.5 70.5V17c0-8.837-7.163-16-16-16h-74c-8.837 0-16 7.163-16 16v52.5"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#email-svg_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#email-svg_svg__h)",
  fillRule: "evenodd",
  d: "M40.5 31.5A2.5 2.5 0 0 1 43 29h36.255a2.5 2.5 0 0 1 0 5H43a2.5 2.5 0 0 1-2.5-2.5",
  clipRule: "evenodd",
  shapeRendering: "crispEdges"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#email-svg_svg__i)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#email-svg_svg__j)",
  fillRule: "evenodd",
  d: "M40.5 45a1.5 1.5 0 0 1 1.5-1.5h53a1.5 1.5 0 0 1 0 3H42a1.5 1.5 0 0 1-1.5-1.5",
  clipRule: "evenodd",
  shapeRendering: "crispEdges"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#email-svg_svg__k)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#email-svg_svg__l)",
  fillRule: "evenodd",
  d: "M40.5 56a1.5 1.5 0 0 1 1.5-1.5h53a1.5 1.5 0 0 1 0 3H42a1.5 1.5 0 0 1-1.5-1.5",
  clipRule: "evenodd",
  shapeRendering: "crispEdges"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "email-svg_svg__b",
  x1: 165.5,
  x2: 27.5,
  y1: 67.5,
  y2: 121,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#380C97"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E49DF5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "email-svg_svg__d",
  x1: 62,
  x2: 100.5,
  y1: 91.5,
  y2: -6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#390C97"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.883,
  stopColor: "#F9DFFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "email-svg_svg__f",
  x1: 173.002,
  x2: -10,
  y1: 168,
  y2: 67,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#360B96",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.587,
  stopColor: "#E49DF5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.857,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "email-svg_svg__h",
  x1: 48,
  x2: 84.5,
  y1: 31.5,
  y2: 31.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.6
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "email-svg_svg__j",
  x1: 49.309,
  x2: 102.668,
  y1: 45,
  y2: 45,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.6
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "email-svg_svg__l",
  x1: 49.309,
  x2: 102.668,
  y1: 56,
  y2: 56,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.6
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "email-svg_svg__a",
  transform: "translate(19.5 3.19)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M66.381 18.825 1 57.52v75.764c0 9.941 8.059 18 18 18h104c9.941 0 18-8.059 18-18V57.519L77.577 18.896a10.88 10.88 0 0 0-11.196-.07"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "email-svg_svg__c",
  transform: "translate(-5 12)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 17c0-8.837 7.163-16 16-16h74c8.837 0 16 7.163 16 16v56.5l-52.5 43L18 71.754z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "email-svg_svg__e",
  transform: "translate(29 -27.386)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m71.792 107.407 68.71-49.05v74.926c0 9.666-7.828 17.5-17.493 17.5H18.959c-9.663 0-17.458-7.831-17.458-17.497V58.349l69.713 49.06.29.204z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "email-svg_svg__g",
  width: 43.255,
  height: 7,
  x: 39.5,
  y: 29,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_13839_33209"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_13839_33209",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "email-svg_svg__i",
  width: 58,
  height: 5,
  x: 39.5,
  y: 43.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_13839_33209"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_13839_33209",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "email-svg_svg__k",
  width: 58,
  height: 5,
  x: 39.5,
  y: 54.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_13839_33209"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_13839_33209",
  result: "shape"
})))));
export default SvgEmailSvg;